import type { ComponentType } from "react";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import When from "ui/support/When";
import { usePaymentMethodsContext } from "../PaymentMethodsProvider";

export const withPaymentMethod = <TProps extends object>(Component: ComponentType<TProps>) =>
    (props: TProps) => {
        const { paymentMethod, resetPaymentMethod } = usePaymentMethodsContext();

        return (
            <When
                if={Boolean(paymentMethod)}
                then={() => (
                    <Card
                        sx={{
                            position: 'relative',
                            p: 2
                        }}
                    >
                        <IconButton
                            sx={{
                                position: 'absolute',
                                top: 8,
                                right: 8
                            }}
                            onClick={resetPaymentMethod}
                        >
                            <CloseIcon />
                        </IconButton>
                        <Component
                            {...props}
                        />
                    </Card>
                )}
            />
        );
    };

export default withPaymentMethod;
